import { useParams } from 'react-router-dom';

import { useProjectBasePath } from 'app/routes/projects/hooks/useProjectPath';
import { useProposalContext } from 'features/project-versioning/hooks/useProposalContext';

import { DecompositionTreePage } from './DecompositionTreePage';

export const NewTreeView = () => {
  const { projectId, nodeId } = useParams<{ nodeId: string; projectId: string }>();
  const { proposalId } = useProposalContext();
  const basePath = useProjectBasePath();

  if (!projectId || !nodeId) return null;

  return (
    <DecompositionTreePage
      key={`${projectId}:${nodeId}:${proposalId ?? 'live'}`}
      projectId={projectId}
      templateNodeId={nodeId}
      proposalId={proposalId}
      basePath={basePath}
    />
  );
};
